export default __webpack_public_path__ + "static/media/webhook.20ba7126.png";